"use client";


import React from "react";
import { createScopeFromContext } from "bunja/react";
import { jsx } from "react/jsx-runtime";

//#region fiber/provider.tsx
const FiberContext = React.createContext(null);
const FiberScope = createScopeFromContext(FiberContext);
var FiberProvider = class extends React.Component {
	_reactInternals;
	render() {
		return /* @__PURE__ */ jsx(FiberContext, {
			value: this._reactInternals,
			children: this.props.children
		});
	}
};

//#endregion
export { FiberContext, FiberProvider, FiberScope };